var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5774 10.4841V7.44195C19.5774 6.88967 19.1297 6.44195 18.5774 6.44195H11.9074C11.6422 6.44195 11.3878 6.33659 11.2003 6.14906L9.76501 4.71379C9.57748 4.52626 9.32312 4.4209 9.05791 4.4209H3.39844C2.84615 4.4209 2.39844 4.86861 2.39844 5.4209V18.5788C2.39844 19.1311 2.84615 19.5788 3.39844 19.5788H4.5746C5.04704 19.5788 5.43002 19.1958 5.43002 18.7234V18.7234C5.43002 18.6208 5.44846 18.5191 5.48448 18.423L8.21827 11.1329C8.36463 10.7426 8.73775 10.4841 9.1546 10.4841H20.211C20.8936 10.4841 21.3755 11.1528 21.1597 11.8003L18.7948 18.895C18.6587 19.3034 18.2765 19.5788 17.8461 19.5788H4.41949",
    stroke: "#18181B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganize);
export default __webpack_public_path__ + "static/media/organize.737741b953641c8de64fd5b247fdbcb3.svg";
export { ForwardRef as ReactComponent };